import getUserSettings from './getUserSettings';

const getUserSetting = async (
  userId: number | string,
  app: string,
  key: string
): Promise<string | null> => {
  const response = await getUserSettings(userId);
  const settings = response?.data ?? [];
  const match = settings.find(
    (s: { app: string; key: string; value: string }) =>
      s.app === app && s.key === key
  );
  return match?.value ?? null;
};

export default getUserSetting;
